<form
    [formGroup]="filterFormGroup"
    #filterForm="ngForm"
    id="filterForm">
    <p-toolbar>
        <p-floatLabel variant="on">
            <p-calendar
                [monthNavigator]="true"
                [yearNavigator]="true"
                [yearRange]="
                    moment().add(-5, 'year').format('YYYY') +
                    ':' +
                    moment().add(5, 'year').format('YYYY')
                "
                formControlName="StartDate"
                dataType="string"
                appendTo="body"
                [inputStyle]="{ width: '7rem' }"
            ></p-calendar>
            <label for="float-dd">Start Date</label>
        </p-floatLabel>
        <p-floatLabel variant="on">
            <p-calendar
                [monthNavigator]="true"
                [yearNavigator]="true"
                [yearRange]="
                    moment().add(-5, 'year').format('YYYY') +
                    ':' +
                    moment().add(5, 'year').format('YYYY')
                "
                formControlName="EndDate"
                dataType="string"
                appendTo="body"
                [inputStyle]="{ width: '7rem' }"
            ></p-calendar>
            <label for="float-dd">End Date</label>
        </p-floatLabel>
        <span *featureFlag="'qboresend'">
            <div class="flex items-center">
                <p-checkbox
                    formControlName="Resend"
                    binary="true">
                </p-checkbox>
                <label class="ml-2" for="Resend">Resend</label>
            </div>

        </span>
        <span *featureFlag="'qboresend'">
            <div class="flex items-center">
                <p-checkbox
                    binary="true"
                    [(ngModel)]="SendDocumentation"
                    (ngModelChange)="SetSendDocumentation.next($event)"
                    [ngModelOptions]="{standalone: true}"
                    >
                </p-checkbox>
                <label class="ml-2">Send Documentation</label>
            </div>

        </span>
    </p-toolbar>
</form>
